import { format } from 'date-fns';
import ruLocale from 'date-fns/locale/ru';
import React from 'react';
import PropTypes from 'prop-types';

import Icon from 'components/Icon';

const TopBar = ({
	onPreviousClick,
	onNextClick,
	showPreviousButton,
	showNextButton,
	month
}) => (
	<div className="DayPicker-TopBar">
		{showPreviousButton && (
			<button
				type="button"
				className="DayPicker-NavButton DayPicker-NavButton--prev"
				onClick={() => onPreviousClick()}
				aria-label="Предыдущий месяц"
				tabIndex="0"
			>
				<Icon icon="chevronLeft" className="DayPicker_icon" />
			</button>
		)}
		<div className="DayPicker-Caption">
			{format(month, 'LLLL yyyy', { locale: ruLocale })}
		</div>
		{showNextButton && (
			<button
				type="button"
				className="DayPicker-NavButton DayPicker-NavButton--next"
				onClick={() => onNextClick()}
				aria-label="Следующий месяц"
				tabIndex="0"
			>
				<Icon icon="chevronRight" className="DayPicker_icon" />
			</button>
		)}
	</div>
);

TopBar.propTypes = {
	onPreviousClick: PropTypes.func.isRequired,
	onNextClick: PropTypes.func.isRequired,
	showPreviousButton: PropTypes.bool.isRequired,
	showNextButton: PropTypes.bool.isRequired,
	month: PropTypes.object.isRequired
};

export default TopBar;
